import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import EmployeeLogin from "@/pages/EmployeeLogin";
import EmployeeClock from "@/pages/EmployeeClock";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import EmployeeManagement from "@/pages/EmployeeManagement";
import TimeEntryManagement from "@/pages/TimeEntryManagement";
import AbsenceManagement from "@/pages/AbsenceManagement";
import AdminSettings from "@/pages/AdminSettings";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/employee" element={<EmployeeLogin />} />
          <Route path="/employee/clock" element={<EmployeeClock />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/employees" element={<EmployeeManagement />} />
          <Route path="/admin/time-entries" element={<TimeEntryManagement />} />
          <Route path="/admin/absences" element={<AbsenceManagement />} />
          <Route path="/admin/settings" element={<AdminSettings />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
